import { useState, useEffect } from 'react';
import { multiversxUrlApi } from 'src/config';
import { handleUnexpectedException } from 'src/helpers/functions';

function useCurrentEpoch() {
    const [currentEpoch, setCurrentEpoch] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCurrentEpoch = async () => {
            try {
                const response = await fetch(multiversxUrlApi + '/blocks/latest');
                const data = await response.json();

                if (response.ok) {
                    setCurrentEpoch(data.epoch);
                } else {
                    handleUnexpectedException(data.message);
                    setError(`Error: ${data.message}`);
                }
            } catch (error) {
                handleUnexpectedException(error);
                setError(`Error: ${error.message}`);
            } finally {
                setLoading(false);
            }
        };

        fetchCurrentEpoch();
    }, []);

    return { currentEpoch, loading, error };
}

export default useCurrentEpoch;
